<template>
  <div>
    <el-row style="height: 60px; line-height: 60px">
      <el-col :span="12" style="text-align: left; font-size: 20px; color: #0a666b">
        <span class="el-icon-chat-dot-round" style="font-size: 22px"></span>
        {{ $t('preprint.myCommentsTitle') }}
      </el-col>
      <el-col :span="12" style="text-align: right">
          <el-button
            type="primary"
            style="background-color: #0a666b; border: none"
            @click="goToPreprintList()"
          >
            {{ $t('preprint.myCommentsViewPreprint') }}
          </el-button>
      </el-col>
    </el-row>

    <el-row style="background-color: white; padding-top: 20px">
      <el-form :inline="true" :model="searchForm" label-width="auto">
        <el-form-item :label="$t('preprint.myCommentsFilterLabel')">
          <el-select v-model="searchForm.status" :placeholder="$t('preprint.myCommentsStatusPlaceholder')">
            <el-option :label="$t('preprint.myCommentsStatusAll')" value=""></el-option>
            <el-option :label="$t('preprint.myCommentsStatusPending')" value="pending"></el-option>
            <el-option :label="$t('preprint.myCommentsStatusApproved')" value="approved"></el-option>
            <el-option :label="$t('preprint.myCommentsStatusRejected')" value="rejected"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            style="background-color: #0a666b; color: white; border: none"
            @click="loadMyCommentList()"
          >
            {{ $t('preprint.myCommentsSearchButton') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row v-if="commentList.length == 0">
      <el-col :span="24">
        <el-empty
          :description="$t('preprint.myCommentsEmpty')"
          style="height: 900px; background-color: white"
        ></el-empty>
      </el-col>
    </el-row>

    <el-row style="min-height: 900px">
      <el-col :span="24" style="margin-top: 10px">
        <el-card
          class="box-card"
          shadow="hover"
          v-for="(item, index) in commentList"
          :key="index"
        >
          <div slot="header" class="card-header clearfix">
            <span class="comment-title">
              {{ $t('preprint.myCommentsCommentOn') }}: {{ item.preprintTitle || $t('preprint.myCommentsDefaultPreprint') }}
            </span>
            <el-tag
              :type="getStatusType(item.status)"
              size="small"
              class="status-tag"
            >
              {{ getStatusText(item.status) }}
            </el-tag>
          </div>
          <el-row>
            <el-col :span="20">
              <div style="margin-bottom: 10px; line-height: 1.6">
                <span style="color: #606266">{{ item.commentContent }}</span>
              </div>
              <div style="font-size: 12px; color: #909399">
                <span>{{ $t('preprint.myCommentsSubmitTime') }}: {{ item.commentTime }}</span>
                <span v-if="item.status === 'rejected'" style="margin-left: 20px">
                  <i class="el-icon-warning" style="color: #F56C6C"></i>
                  {{ $t('preprint.myCommentsRejectReason') }}: {{ item.rejectReason || $t('preprint.myCommentsRejectReasonNone') }}
                </span>
              </div>
            </el-col>
            <el-col :span="4" style="text-align: right">
              <el-button
                size="small"
                type="primary"
                @click="viewPreprint(item.preprintId)"
                style="background-color: #09666c; border: none; margin-bottom: 5px"
              >
                {{ $t('preprint.myCommentsViewPreprint') }}
              </el-button>
              <br />
              <el-button
                size="small"
                type="danger"
                @click="handleDeleteComment(item.id)"
                style="margin-top: 5px"
              >
                <i class="el-icon-delete"></i> {{ $t('preprint.detailDeleteComment') }}
              </el-button>
            </el-col>
          </el-row>
        </el-card>

        <br />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getMyCommentList, deleteComment } from '@/api/preprint'

export default {
  name: 'myCommentList',
  data() {
    return {
      userInfo: null,
      searchForm: {
        status: ''
      },
      commentList: [],
      currentPage: 1,
      pageSize: 10,
      pageTotal: 0
    }
  },
  methods: {
    goToPreprintList() {
      this.$router.push({ name: 'preprintList' })
    },
    viewPreprint(preprintId) {
      this.$router.push({
        name: 'preprintDetail',
        query: { id: preprintId }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadMyCommentList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadMyCommentList()
    },
    getStatusType(status) {
      const typeMap = {
        pending: 'primary',
        approved: 'success',
        rejected: 'danger'
      }
      return typeMap[status] || 'info'
    },
    getStatusText(status) {
      const textMap = {
        pending: this.$t('preprint.myCommentsStatusPending'),
        approved: this.$t('preprint.myCommentsStatusApproved'),
        rejected: this.$t('preprint.myCommentsStatusRejected')
      }
      return textMap[status] || status
    },
    loadMyCommentList() {
      if (!this.userInfo) {
        this.$message.error(this.$t('preprint.myCommentsNeedLogin'))
        this.$router.push({ name: 'login' })
        return
      }

      getMyCommentList({
        userInfo: {
          email: this.userInfo.email
        },
        current: this.currentPage,
        size: this.pageSize
      }).then((res) => {
        if (res.data.errorCode === 0) {
          this.commentList = res.data.result.records || []
          this.pageTotal = res.data.result.total || 0
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.myCommentsLoadFailed'))
        }
      }).catch((err) => {
        console.error('加载我的评论列表错误:', err)
        this.$message.error(this.$t('preprint.myCommentsLoadFailed'))
      })
    },
    handleDeleteComment(commentId) {
      this.$confirm(
        this.$t('preprint.detailDeleteCommentConfirm'),
        this.$t('preprint.detailDeleteComment'),
        {
          confirmButtonText: this.$t('preprint.detailDeleteComment'),
          cancelButtonText: this.$t('preprint.pendingDialogCancel'),
          type: 'warning'
        }
      ).then(() => {
        deleteComment({
          userInfo: {
            email: this.userInfo.email,
            type: this.userInfo.type
          },
          commentId: commentId
        }).then((res) => {
          if (res.data.errorCode === 0) {
            this.$message.success(this.$t('preprint.detailDeleteCommentSuccess'))
            // 重新加载评论列表
            this.loadMyCommentList()
          } else {
            this.$message.error(res.data.errorMessage || this.$t('preprint.detailDeleteCommentFailed'))
          }
        }).catch((err) => {
          console.error('删除评论错误:', err)
          this.$message.error(this.$t('preprint.detailDeleteCommentFailed'))
        })
      }).catch(() => {
        // 用户取消删除
      })
    }
  },
  mounted() {
    this.userInfo = this.$cookie.getCookie('userInfo')
    this.loadMyCommentList()
  }
}
</script>

<style scoped>
.box-card {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 10px;
}

/* 卡片头部样式，确保标题完整显示 */
.card-header {
  min-height: 40px;
  padding: 10px 0;
  line-height: 1.5;
  overflow: visible;
}

.card-header::after {
  content: "";
  display: table;
  clear: both;
}

/* 标题样式，确保不被遮挡 */
.comment-title {
  color: #0a666b;
  font-weight: 900;
  float: left;
  line-height: 1.5;
  padding: 5px 0;
  word-break: break-word;
  overflow: visible;
  max-width: calc(100% - 120px);
}

/* 状态标签样式 */
.status-tag {
  float: right;
  margin-left: 10px;
  margin-top: 5px;
}
</style>




// WEBPACK FOOTER //
// src/view/preprint/myCommentList.vue